import angular from 'angular';
import BalanceChartComponent from './balanceChart.component';

const balanceChartModule = angular.module('tinaba.common.balanceChart', [])

.component('balanceChart', BalanceChartComponent);

export default balanceChartModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/balanceChart/balanceChart.js
 **/